import {useTranslation} from 'react-i18next';
import {VERIFICATION_METHODS} from '@guestapp/sdk';
import {ContactsVerificationCodes} from './components/ContactsVerificationCodes';
import {EmailInput} from './components/ContactsForm/EmailInput';
import {ContactsForm} from './components/ContactsForm';
import {PageWrapper} from './components/PageWrapper';
import {useVerification} from './useVerification';
import {VerificationStep} from './constants';
import {FormTypes} from './types';

type Props = {
  currentStep: VerificationStep;
  onGenerate?: () => void;
  onVerify?: (data: string, isVerified: boolean) => void;
  onChangeContacts?: () => void;
};

const EmailVerification = ({
  currentStep,
  onGenerate = () => {},
  onVerify = () => {},
  onChangeContacts = () => {},
}: Props) => {
  const {t} = useTranslation();

  const {isLoading, contactsData, resendCode, verifyCode, onSubmit} = useVerification({
    type: VERIFICATION_METHODS.email,
    onGenerate,
    onVerify,
    isMock: import.meta.env.DEV,
  });

  const handleSubmit = (data: FormTypes) => {
    return onSubmit(data?.email || '');
  };

  return (
    <PageWrapper
      title={
        currentStep === VerificationStep.CONTACTS_INPUT ? t('verify_your_email') : ''
      }
      subtitle={t('contacts_verification_info')}
    >
      {currentStep === VerificationStep.CODES_VERIFICATION && (
        <ContactsVerificationCodes
          title={t('enter_code', {type: t('email').toLocaleLowerCase()})}
          sentToValue={contactsData}
          type={VERIFICATION_METHODS.email}
          onVerifyCodes={verifyCode}
          onResendCodes={resendCode}
          onChangeContacts={onChangeContacts}
          isLoading={isLoading}
        />
      )}
      {currentStep === VerificationStep.CONTACTS_INPUT && (
        <ContactsForm
          type={VERIFICATION_METHODS.email}
          isLoading={isLoading}
          onSubmit={handleSubmit}
        >
          <EmailInput name="email" label={t('email')} />
        </ContactsForm>
      )}
    </PageWrapper>
  );
};

export {EmailVerification};
